module.exports = _.isEmpty;